import axios from "@/http";

class AbnormalOrder {
  // 未维护映射关系预警列表
  static getOrderErrRecordList(customerName) {
    const url = `/oa/api/order/get/order/failure?customerName=${customerName}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 未维护映射关系预警重新导入
  static postWmsReimport() {
    const url = "/oa/api/order/import/order/failure";
    return axios.post(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 未维护商品重量预警列表
  static getCommodityWeightAlertNotMaintainedList(goodsOwner, pageNo, warehouseId) {
    const url = `/oa/api/order/get/order/exception?goodsOwner=${goodsOwner}&pageNo=${pageNo}&warehouseId=${warehouseId}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 未维护商品重量预警列表---完成维护
  static postMaintained(data) {
    const url = "/oa/api/order/fixed/order/exception";
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
}

export default AbnormalOrder;